import { useMediaQuery } from '@mui/material'
import Box from '@mui/material/Box'
import MobileMainHeader from 'Components/_common/MobileMainHeader'
import PageBackground from 'Components/_common/PageBackground'
import Filter from 'Components/Filter'
import FilterControl from 'Components/Filter/FilterControl'
import { FilterControlsSlot, TagsSlot } from 'Components/Filter/slots'
import MainHeader from 'Components/Layout/MainHeader'
import { BackgroundPlug } from 'Components/Layout/MainLayout'
import { SearchContext } from 'Components/Layout/MainLayout/SearchContext'
import InfiniteContentCardsList from 'Components/MapsComponents/MapCardsList/InfiniteContentCardsList'
import SearchBlock from 'Components/SearchComponents/SearchBlock'
import { MobileSearch } from 'Components/SearchComponents/SearchBlock/MobileSearch/MobileSearch'
import SearchTabs from 'Components/SearchComponents/SearchTabs'
import { useOpaque } from 'hooks/useOpaque'
import React, { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import ReactStickyBox from 'react-sticky-box'
import { CONTENT_TYPES } from 'Scenes/constants'
import { BREAKPOINT_MIN_MD } from 'Theme/stylesUtil'

import BackgroundImage from '../../Assets/img/CommonPageBackground.jpg'

const SceneSearch = () => {
  const isBiggerThanMDScreen = useMediaQuery(BREAKPOINT_MIN_MD)
  const location = useLocation()
  const isOpaque = useOpaque()
  const { value = '' } = location.state || {}
  const [contentType, setContentType] = useState(CONTENT_TYPES.MAPS)
  const [mapsTotal, setMapsTotal] = useState()
  const [prefabsTotal, setPrefabsTotal] = useState()

  const { setSearch } = useContext(SearchContext)

  useEffect(() => {
    value && setSearch(value)
  }, [setSearch, value])

  return (
    <>
      <BackgroundPlug>
        <PageBackground
          height={570}
          imageElement={
            <img
              src={BackgroundImage}
              alt="Background"
              style={{ filter: 'brightness(40%)' }}
            />
          }
        />
      </BackgroundPlug>

      <Filter>
        <MainHeader
          searchHeader={
            <SearchBlock
              inputStyle={{ background: '#00000026' }}
              variant="h2"
              fullWith
            />
          }
          subheader={
            <Box
              display="flex"
              justifyContent="space-between"
              px={4}
            >
              <SearchTabs
                contentType={contentType}
                setContentType={setContentType}
                mapsTotal={mapsTotal}
                prefabsTotal={prefabsTotal}
              />
              <FilterControlsSlot />
            </Box>
          }
        />

        <Box
          paddingLeft={5}
          paddingRight={5}
        >
          {isBiggerThanMDScreen ? (
            <Box
              display="flex"
              alignItems="center"
              mt={15}
              width="100%"
              justifyContent="space-between"
            >
              <SearchBlock />
              <FilterControlsSlot />
            </Box>
          ) : (
            <MobileMainHeader>
              <MobileSearch
                contentType={contentType}
                setContentType={setContentType}
                mapsTotal={mapsTotal}
                prefabsTotal={prefabsTotal}
              />
            </MobileMainHeader>
          )}

          <Box
            display="flex"
            flexDirection="column"
            paddingTop={isBiggerThanMDScreen ? 5 : 10}
            paddingBottom={5}
          >
            {!isOpaque && isBiggerThanMDScreen && (
              <Box mb={4}>
                <SearchTabs
                  contentType={contentType}
                  setContentType={setContentType}
                  mapsTotal={mapsTotal}
                  prefabsTotal={prefabsTotal}
                />
              </Box>
            )}
            <Box display="flex">
              <Box style={{ flex: '1' }}>
                {isBiggerThanMDScreen && <TagsSlot />}

                <Box
                  pr={isBiggerThanMDScreen ? 5 : 0}
                  mt={isBiggerThanMDScreen ? 0 : 10}
                >
                  <InfiniteContentCardsList
                    type={contentType}
                    setMapsTotal={setMapsTotal}
                    setPrefabsTotal={setPrefabsTotal}
                  />
                </Box>
              </Box>

              {isBiggerThanMDScreen && (
                <Box>
                  <ReactStickyBox
                    offsetTop={120}
                    offsetBottom={20}
                  >
                    <FilterControl type={contentType} />
                  </ReactStickyBox>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Filter>
    </>
  )
}

export default SceneSearch
